jQuery(document).ready(function ($) {

    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 3.5,
        spaceBetween: 10,
        freeMode: true
    });

    function mostrarElemento(elemento) {
        $('.contenido').each(function () {
            // Pause all videos in other .contenido elements
            $(this).find('video').each(function () {
                this.pause();
            });
        });

        // Hide all .contenido elements and then show the current one
        $('.contenido').hide();
        elemento.show();
        elemento.find('#submenu-content-1').show();

        // Play the video in the current elementoAMostrar, if it exists
        var video = elemento.find('video').get(0);
        if (video) {
            video.play();
            if (video.muted = true) {
                video.muted = false
            }
        }
    }

    var enlacesElementos = {
        'rellenos_nordicos': {
            elemento: $('#landing-rellenos-nordicos'),
            submenu: 'submenu1',
        },
        'almohadas': {
            elemento: $('#landing-almohada'),
            submenu: 'submenu1',
        },
        'protectores_de_almohadas': {
            elemento: $('#landing-protectores-almohadas'),
            submenu: 'submenu1',
        },
        'protectores_de_colchones': {
            elemento: $('#landing-protectores-colchones'),
            submenu: 'submenu1',
        },
        'como_cuidarlos': {
            elemento: $('#landing-cuidarlos'),
            submenu: 'submenu1',
        }
    };

    // Maneja el clic en los enlaces del menú
    $('.menu-item').click(function () {
        var menuItemClasses = $(this).attr('class').split(' ');
        var menuItemTitles = $(this).find('p').text();
        $('.menu-item').removeClass('active');
        $(this).addClass('active');

        $('.landing-main-container h2').text(menuItemTitles);

        $('.contenido').css('display', 'none');

        for (var i = 0; i < menuItemClasses.length; i++) {
            var currentClass = menuItemClasses[i];

            if (enlacesElementos[currentClass]) {
                var elementoAMostrar = enlacesElementos[currentClass].elemento;
                mostrarElemento(elementoAMostrar);
            }
        }
    });

    $('.contenido').each(function () {
        var elementoAMostrar = $(this);
        // var submenuId = enlacesElementos[elementoAMostrar.attr('id')].submenu;

        elementoAMostrar.find('#submenu1').click(function () {
            elementoAMostrar.find('.submenu').removeClass('active');
            elementoAMostrar.find(this).addClass('active');

            elementoAMostrar.find('.submenu-content').hide();
            elementoAMostrar.find('#submenu-content-1').fadeIn();
        });

        elementoAMostrar.find('#submenu2').click(function () {
            elementoAMostrar.find('.submenu').removeClass('active');
            elementoAMostrar.find(this).addClass('active');

            elementoAMostrar.find('.submenu-content').hide();
            elementoAMostrar.find('#submenu-content-2').fadeIn();
        });

        elementoAMostrar.find('#submenu3').click(function () {
            elementoAMostrar.find('.submenu').removeClass('active');
            elementoAMostrar.find(this).addClass('active');

            elementoAMostrar.find('.submenu-content').hide();
            elementoAMostrar.find('#submenu-content-3').fadeIn();
        });

        elementoAMostrar.find('#submenu4').click(function () {
            elementoAMostrar.find('.submenu').removeClass('active');
            elementoAMostrar.find(this).addClass('active');

            elementoAMostrar.find('.submenu-content').hide();
            elementoAMostrar.find('#submenu-content-4').fadeIn();
        });

        elementoAMostrar.find(".submenu").click(function () {
            $(this).parent().children(".submenu-content").slideToggle("slow", function () { });
            $(this).children("img").toggleClass("inverse");
        });
    });

    // showFirstSubmenu($('#landing-rellenos-nordicos'));

    var elementos = Object.values(enlacesElementos); // Obten todos los elementos configurados
    var elementoActual = 0; // Inicialmente, muestra el primer elemento

    // Función para mostrar el elemento actual
    function mostrarElementoActual() {
        $('.contenido').each(function () {
            // Pause all videos in .contenido elements
            $(this).find('video').each(function () {
                this.pause();
            });
        });

        // Oculta todos los elementos
        $('.contenido').hide();

        // Muestra el elemento actual
        var currentElement = elementos[elementoActual].elemento;
        currentElement.show();

        // Play the video in the current elemento
        var video = currentElement.find('video').get(0);
        if (video) {
            video.play();
            if (video.muted = true) {
                video.muted = false
            }
        }

        // Agrega la clase "active" al menú correspondiente
        $('.menu-item').removeClass('active');
        var elementoActualID = Object.keys(enlacesElementos)[elementoActual];
        $('.menu-item.' + elementoActualID).addClass('active');

        // Restablece los estilos de submenu
        $('.submenu').removeClass('active');
        $('.submenu-content').hide();
        // Muestra el primer submenú
        elementos[elementoActual].elemento.find('#submenu1').addClass('active');
        elementos[elementoActual].elemento.find('#submenu-content-1').show();
    }

    // Configura el botón .izq para mostrar el elemento anterior
    $('.arrow-left').click(function () {
        elementoActual = (elementoActual - 1 + elementos.length) % elementos.length;
        mostrarElementoActual();
    });

    // Configura el botón .dcha para mostrar el elemento siguiente
    $('.arrow-right').click(function () {
        elementoActual = (elementoActual + 1) % elementos.length;
        mostrarElementoActual();
    });

    // Muestra el primer elemento al cargar la página
    mostrarElementoActual();


    /*===================================*
    09. SCROLLUP JS
    *===================================*/
    $(window).scroll(function () {
        if ($(this).scrollTop() > 150) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $(".scrollup").on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 600);
        return false;
    });




});

